(() => {
  const script = document.currentScript;
  const standingUrl = new URL('mascot-standing-transparent.png', script.src).href;
  const packagingUrl = new URL('mascot-with-pack-transparent.png', script.src).href;
  const placements = [
    ['.hero-copy', 'Meet your everyday kitchen helper.'],
    ['.shop-intro', 'A little disc. A little less fuss.'],
    ['.care > div:first-child', 'Clean gently. Ready for tomorrow.'],
    ['.support > div:first-child', 'A friendly helping hoof.'],
    ['.purchase-panel', 'A friendly reminder to check the pot.'],
    ['.journal-intro', 'Curious minds. Calmer kitchens.'],
    ['.article-header', 'Little things, better understood.'],
    ['.review-summary', 'Tell us about your everyday ritual.']
  ];
  function decorate() {
    for (const [selector, caption] of placements) {
      const host = document.querySelector(selector);
      if (!host || host.querySelector('.mascot-spot')) continue;
      const figure = document.createElement('figure');
      figure.className = 'mascot-spot';
      const img = document.createElement('img');
      const withPack = ['.hero-copy', '.shop-intro', '.purchase-panel'].includes(selector);
      figure.classList.add(withPack ? 'mascot-pack' : 'mascot-standing');
      img.src = withPack ? packagingUrl : standingUrl;
      img.alt = withPack ? 'Damroo cow mascot holding the branded product box' : 'Smiling black-and-white Damroo cow mascot';
      img.width = withPack ? 1012 : 853; img.height = withPack ? 1024 : 1280;
      img.loading = selector === '.hero-copy' ? 'eager' : 'lazy';
      const copy = document.createElement('figcaption');
      copy.textContent = caption;
      figure.append(img, copy);
      if (selector === '.purchase-panel') host.insertBefore(figure, host.querySelector('.detail-packs'));
      else if (selector === '.hero-copy') host.insertBefore(figure, host.querySelector('.hero-meta'));
      else host.append(figure);
    }
    const tile = document.querySelector('.social-tile');
    if (tile && !tile.querySelector('.social-mascot')) {
      const symbol = tile.querySelector('.social-symbol');
      if (symbol) {
        const img = document.createElement('img');
        img.src = packagingUrl; img.alt = ''; img.className = 'social-mascot';
        img.loading = 'lazy'; img.width = 1012; img.height = 1024;
        symbol.replaceWith(img);
      }
    }
  }
  decorate();
  // Community content is mounted by a separate local script.
  const mount = document.querySelector('main');
  if (mount && !document.querySelector('.review-summary')) {
    const observer = new MutationObserver(() => {
      if (document.querySelector('.review-summary')) { decorate(); observer.disconnect(); }
    });
    observer.observe(mount, {childList:true, subtree:true});
    addEventListener('pagehide', () => observer.disconnect(), {once:true});
  }
})();
